import { instance } from '@/api/instances'

const prefix = 'counter_referrals/'

const getBasicInfo = async store => {
  try {
    const response = await instance.get(
      `${store.rootState.pillars.personId}/${prefix}referral/basicInfo/`
    )

    if (response.status === 204) {
      return null
    }

    const json = await response

    return json
  } catch {
    return null
  }
}

const getLastCRData = async (_, personId) => {
  try {
    return await instance.get(`${personId}/${prefix}referral/last/`)
  } catch {
    return {}
  }
}

export default {
  getBasicInfo,
  getLastCRData
}
